const prepareItems = (itemsList) => {
  const map = new Map();
  const sortableItems = itemsList.map((item) => {
    const orderParts = item.order.split('.').map(Number);
    const parentOrder =
      orderParts.length > 1 ? item.order.substring(0, item.order.lastIndexOf('.')) : null;

    return {
      original: item,
      orderParts,
      parentOrder,
    };
  });

  sortableItems.sort((a, b) => {
    const arrayOfA = a.orderParts;
    const arrayOfB = b.orderParts;
    const minLength = Math.min(arrayOfA.length, arrayOfB.length);

    for (let index = 0; index < minLength; index += 1) {
      const diff = arrayOfA[index] - arrayOfB[index];
      if (diff !== 0) return diff;
    }

    return arrayOfA.length - arrayOfB.length;
  });

  return sortableItems.reduce((result, item) => {
    const extendedItem = {
      ...item.original,
      items: [],
    };

    map.set(item.original.order, extendedItem);

    if (item.parentOrder) {
      const parent = map.get(item.parentOrder);
      if (parent?.items) {
        parent.items.push(extendedItem);
      } else {
        result.push(extendedItem);
      }
    } else {
      result.push(extendedItem);
    }

    return result;
  }, []);
};

export default prepareItems;
